module.exports = __webpack_public_path__ + "static/media/striped_bar_M1.e8c43397.svg";